<template>
  <v-dialog v-model="dOpenComponente" persistent full-width>
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{dInformeComponente.nombre}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <DevExtremeTable ref="DataTableExtrem" :pPagination="dPagination"></DevExtremeTable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

// COMPONENTES

import DevExtremeTable from '@/components_datadec/DevExtremeTable'

export default {
  data () {
    return {
      dOpenComponente: true,
      dInformeComponente: null,
      dDatosComprasVentas: [],
      dPagination: {
        'numRows': 10,
        'showPageSize': true,
        'showNavigation': true,
        'showText': true,
        'arrayRows': [ 5, 10, 15 ]
      }

    }
  },
  components: {DevExtremeTable},
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: true
    }
  },
  created () {
    this.dInformeComponente = this.pInformeComponente
  },
  mounted () {
    this.fLoadData()
  },
  methods: {
    fLoadData () {
      /* l */
    },
    fCerrarVentana () {
      this.$emit('close')
    },
    fAlert (msg) {
      this.$emit('alert', msg)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/ComprasVentas/ShpComprasVentas.vue